var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnhide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6118 6.49244L14.9853 9.21228L15.0013 9.06981C15.0013 7.64081 13.5609 6.47949 11.7885 6.47949L11.6118 6.49244Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7882 4.75234C14.7451 4.75234 17.1449 6.68646 17.1449 9.06955C17.1449 9.62647 17.0057 10.1575 16.7646 10.6453L19.8983 13.1709C21.516 12.0829 22.7909 10.6755 23.5783 9.06955C21.7196 5.27906 17.1503 2.59375 11.7883 2.59375C10.2884 2.59375 8.85286 2.8096 7.51904 3.19814L9.83313 5.05884C10.4384 4.8689 11.0972 4.75234 11.7882 4.75234Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07522 2.39923L3.51787 4.36787L4.00534 4.76075C2.23764 5.87459 0.839548 7.3554 0.00390625 9.0693C1.85733 12.8598 6.43192 15.5451 11.7886 15.5451C13.4492 15.5451 15.0348 15.2861 16.4864 14.8155L16.9418 15.1825L20.0647 17.7037L21.4307 16.6071L2.44118 1.29834L1.07522 2.39923ZM6.99974 7.16975L8.65495 8.50376C8.60674 8.68942 8.5746 8.87503 8.5746 9.0693C8.5746 10.4983 10.0155 11.6596 11.7886 11.6596C12.0297 11.6596 12.26 11.6337 12.485 11.5949L14.1402 12.9289C13.4278 13.2138 12.635 13.3865 11.7886 13.3865C8.83173 13.3865 6.43192 11.4524 6.43192 9.0693C6.43192 8.3872 6.6462 7.74824 6.99974 7.16975Z",
    fill: "#A8A8A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.5747,
    height: 19,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhide);
export default __webpack_public_path__ + "static/media/unhide.11deecb01fbb562ad530141be210f78d.svg";
export { ForwardRef as ReactComponent };